import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { routes } from "./modal-demo.routes";

@NgModule({
	imports: [RouterModule.forChild(routes)]
})
export class ModalDemoEntryModule {}
